
export const localParticipantData = [
    {name: 'User', id: 'xd4bvsf1'},
    {name: 'Guru', id: 'xdfvsf1'},
    {name: 'Bharath', id: 'xdf1sf2'},
    {name: 'Brajendra', id: 'xd3vsf3'  },
    {name: 'Harish', id: 'xdf2sf4'  },
    {name: 'Sachin', id: 'xd4vsf5'  },
    {name: 'Rahul', id: 'xd5vsf6'  },
    {name: 'Sarvesh', id: 'xd6vsf7'  },
    {name: 'Suryansh', id: 'x7fvsf8'  },
    {name: 'Raees', id: 'x8fvsf9'  },
    {name: 'Iqbal', id: 'x9fvsf10'  },
    {name: 'Chaman', id: 'xdf10vsf11'  },
    {name: 'Parekh', id: 'xd11vsf12'  },
    {name: 'Rohan', id: 'x12fvsf13'  },
    {name: 'Farish', id: 'x13fvsf14'  },
    {name: 'Hasan', id: 'x14fvsf15'  },
    {name: 'Sandeep', id: 'x15fvsf16'  }   
]